import cx from 'classnames'
import styles from './GithubInline.module.scss'
import { PullResponse } from './types'
import { githubPullIcon } from './common'
import { ReactComponent as GithubLogo } from 'assets/icons/logos/github24.svg'
import { StrongNode, nodes } from 'prose-core'
import { AnchorOrDiv, Skel } from '../EmbedCommon/common'

export type GithubInlineProps = {
  node: StrongNode<typeof nodes.github_embed>
  isLoading: boolean
  status: 'merged' | 'open' | 'open-issue' | 'closed' | 'closed-issue' | 'draft'
  data: PullResponse
  preview?: true
}
export const GithubInline = (props: GithubInlineProps) => {
  const { node, isLoading, status, data, preview } = props

  return isLoading ? (
    <div className={cx(styles.inline, styles.isLoading)}>
      <div className={styles.icon}>
        <GithubLogo width={20} height={20} />
      </div>
      <div className={styles.body}>
        <Skel />
      </div>
    </div>
  ) : (
    <div className={cx(styles.issue, styles[node.attrs.mode], { [styles.isLoading]: isLoading })}>
      <div className={cx(styles.icon, styles[status])}>{githubPullIcon(status)}</div>

      <AnchorOrDiv link={preview ? undefined : node?.attrs.link} className={styles.content}>
        {`${data?.title} #${data?.number}`}
      </AnchorOrDiv>
    </div>
  )
}
